import React from 'react';
import { NavLink, Route, Switch, NavLinkProps } from 'react-router-dom';
import styled from 'styled-components';

import { AccountInfoScreen, UsersAndPermissionsScreen } from '..';
import { Box, FlexContainer, Text } from '../../../../shared/Typhography';
import { strings } from '../../../../strings';
import { DashboardRoutePath } from '../../navigation/path';

import { UsersPermissionsIcon, AccountInfoIcon } from './Icons';

const Container = styled(FlexContainer)`
  margin: 150px auto;
  width: 80%;
`;

const SelectSetting = styled(NavLink)<NavLinkProps>`
  display: flex;
  cursor: pointer;
  text-decoration: none;
  gap: 1rem;
  position: relative;
  padding: 15px;
  color: ${({ theme }) => theme.colors.darkGray};
  &:hover {
    color: ${({ theme }) => theme.colors.purple};
  }
  &.${({ activeClassName }) => activeClassName} {
    background-color: ${({ theme }) => theme.colors.lightPurple};
    color: ${({ theme }) => theme.colors.purple};
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 2px;
      height: 50px;
      background-color: ${({ theme }) => theme.colors.purple};
    }
  }
`;

const SettingsScreen = () => {
  return (
    <Container alignItems="flex-start" gap="3rem" justifyContent="flex-start">
      <Box overflow="hidden" width="20%" margin="0" padding="0">
        <FlexContainer flexDirection="column">
          <Text padding="15px" size={1.1} weight="bold">
            Settings
          </Text>
          <SelectSetting
            activeClassName="any"
            to={`/${DashboardRoutePath.SETTINGS}/${DashboardRoutePath.ACCOUNT_INFO}`}
          >
            <AccountInfoIcon />
            {strings.accountInfo}
          </SelectSetting>
          <SelectSetting
            activeClassName="any"
            to={`/${DashboardRoutePath.SETTINGS}/${DashboardRoutePath.USERS}`}
          >
            <UsersPermissionsIcon />
            {strings.usersAndPermissions}
          </SelectSetting>
        </FlexContainer>
      </Box>
      <Switch>
        <Route path={`/${DashboardRoutePath.SETTINGS}/${DashboardRoutePath.ACCOUNT_INFO}`}>
          <AccountInfoScreen />
        </Route>
        <Route path={`/${DashboardRoutePath.SETTINGS}/${DashboardRoutePath.USERS}`}>
          <UsersAndPermissionsScreen />
        </Route>
      </Switch>
    </Container>
  );
};

export default SettingsScreen;
